// extracted by mini-css-extract-plugin
export default {"bottom":"AuthBottom_bottom__NRYp7","snsIcon":"AuthBottom_snsIcon__E4UaJ"};